export default __webpack_public_path__ + "static/media/416.3965306c.gif";